<script>
import MetadataCategories from './MetadataCategories.js';

export default {
  name: 'MediaMetadata',
  props: {
    metadata: Object,
  },
  computed: {
    metadataFields() {
      const unusedKeys = new Set(Object.keys(this.metadata));
      const mappedCategories = [];
      let categoryFields;

      const processField = (field) => ({
        key: field.toLowerCase(),
        // Space-pad all words, beginning with a capital letter or entire abbreviates.
        label: field.replace(/([A-Z][a-z]+|[A-Z]+(?![a-z]))/g, ' $1'),
        value: this.metadata[field],
      })

      for (const category of MetadataCategories) {
        categoryFields = [];

        for (const field of category.tags) {
          if (unusedKeys.has(field)) {
            categoryFields.push(processField(field));
            unusedKeys.delete(field);
          }
        }

        if (categoryFields.length > 0) {
          mappedCategories.push({
            key: category.key,
            name: this.$t(`routes.pod.metadataCategories.${category.key}`),
            fields: categoryFields,
          });
        }
      }

      if (unusedKeys.size > 1) {
        mappedCategories.push({
          key: 'miscellaneous',
          name: this.$t(`routes.pod.metadataCategories.miscellaneous`),
          fields: Array.from(unusedKeys.values()).map(processField),
        })
      }

      return mappedCategories;
    },
    embeddedMapUrl() {
      const gpsPosition = this.metadata['GPSPosition'];
      const googleMapsApiKey = import.meta.env.VITE_GOOGLE_MAPS_KEY;

      if (!gpsPosition || !googleMapsApiKey) {
        return null;
      }

      const encodedGPSPosition = encodeURIComponent(gpsPosition.replaceAll('deg', '°').replaceAll(' ', ''));
      return `https://www.google.com/maps/embed/v1/place?key=${googleMapsApiKey}&q=${encodedGPSPosition}`;
    },
  },
};
</script>

<template>
  <div class="pod-information-section">
    <div v-for="category in metadataFields" class="pod-information-section-category" :key="`metadata_category_${category.key}`">
      <div class="d-flex pod-information-section-category-title">{{ category.name }}</div>
      <div v-for="field in category.fields" :key="`metadata_field_${field.key}`"
           class="d-flex pod-information-section-row">
        <div>{{ field.label }}</div>
        <div v-if="Array.isArray(field.value)">
          <ul>
            <li v-for="(value, idx) in field.value" :key="`metadata_field_${field.key}_${idx}`">{{ value }}</li>
          </ul>
        </div>
        <div v-else>{{ field.value }}</div>
      </div>
    </div>


    <iframe
      v-if="embeddedMapUrl"
      class="mt-2"
      width="100%"
      height="450"
      style="border:0"
      loading="lazy"
      allowfullscreen
      referrerpolicy="no-referrer-when-downgrade"
      :src="embeddedMapUrl"
      :aria-label="$t('routes.pod.metadata.locationMap')"
    />
  </div>
</template>
